import { z } from "zod";
import { tableRowSchema, tableArtifactDataSchema } from "./artifact";

// The typed row shape for a keyword research table. The generic `table` artifact
// stays domain-agnostic (freeform columns + catchall cells); this is the row
// CONTRACT the langgraph builder emits and the frontend reads — the single
// source for keyword cell keys, shared so producer and consumer never drift.

export const KeywordTiers = ["top_pick", "solid", "niche"] as const;
export type KeywordTier = (typeof KeywordTiers)[number];

/** Google ad-auction competition bucket (NOT SEO difficulty). */
export const CompetitionLevels = ["low", "medium", "high"] as const;
export type CompetitionLevel = (typeof CompetitionLevels)[number];

export const keywordRowSchema = tableRowSchema.extend({
  keyword: z.string(),
  searchVolume: z.number(),
  cpc: z.number().nullable().optional(),
  competition: z.number().optional(), // 0–1 ad competition
  competitionLevel: z.enum(CompetitionLevels).optional(),
  intent: z.string().optional(), // main_intent: commercial / informational / …
  // Launch10 Score: our 0–100 paid-fit opinion (= backend `rank`). The hero
  // column, the default sort, and what the Simple-view tier is bucketed from.
  launch10Score: z.number(),
});
export type KeywordRow = z.infer<typeof keywordRowSchema>;

// KeywordsTable ⊂ ReviewableTable: the same renderable table-artifact data shape
// (columns + approval), narrowed so every row is a typed KeywordRow. The agent
// never authors this — the builder hydrates it from a keyword_research pull.
export const keywordTableDataSchema = tableArtifactDataSchema.extend({
  rows: z.array(keywordRowSchema),
});
export type KeywordTableData = z.infer<typeof keywordTableDataSchema>;
